import { userContext } from '../userManager';

export const apiTransactionsGet = (id) =>
  userContext.apiCall({ url: `/wallets/${id}/transactions` });

// Deposit - Withdraw - PortfolioDeposit - PortfolioWithdraw
export const apiTransactionsPost = (walletId, { amount, portfolioId, type, pin }) =>
  userContext.apiCall({
    url: `/wallets/${walletId}/transactions`,
    method: 'POST',
    body: {
      amount: Number(amount),
      portfolioId,
      type,
      userPin: pin,
    },
  });
